import { render, staticRenderFns } from "./RemoveUser.vue?vue&type=template&id=75410380&scoped=true&"
import script from "./RemoveUser.vue?vue&type=script&lang=js&"
export * from "./RemoveUser.vue?vue&type=script&lang=js&"
import style0 from "./RemoveUser.vue?vue&type=style&index=0&id=75410380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75410380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75410380')) {
      api.createRecord('75410380', component.options)
    } else {
      api.reload('75410380', component.options)
    }
    module.hot.accept("./RemoveUser.vue?vue&type=template&id=75410380&scoped=true&", function () {
      api.rerender('75410380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/RemoveUser.vue"
export default component.exports